import React from 'react'

import { useAdminRoutes } from '@hozana/router/useAdminRoutes'

import { Link } from 'elements/text/Link'
import { Text } from 'elements/text/Text'
import { Alert, TAlertProps } from 'elements/ui/Alert'

import type { TCommunity } from '../types'

export type TCommunityDraftExplanationProps = {
  community: TCommunity
  shortText?: boolean
} & TAlertProps

/**
 * ### CommunityDraftExplanation ###
 */
export const CommunityDraftExplanation: TFCC<TCommunityDraftExplanationProps> = ({
  community,
  shortText,
  ...otherProps
}) => {
  const adminRoutes = useAdminRoutes()

  return (
    <Alert status="neutral" hideCloseButton {...otherProps}>
      <Text inline>
        {shortText
          ? 'trans:community:community.status.draft.explanation.short'
          : 'trans:community:community.status.draft.explanation.long'}
      </Text>
      {!shortText && (
        <Link
          to={adminRoutes.communityEdit({ communityId: community.id })}
          reload
          color="blue"
          underline
          hoverColor="darkBlue"
        >
          <Text inline>trans:community:community.edit.edit</Text>
        </Link>
      )}
    </Alert>
  )
}
